import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';

const RefundPurchaseButton = ({ handleClick, className }) => {
  const handleTrueRefund = () => handleClick('true_refund');
  const handleCorrectionRefund = () => handleClick('correction_refund');

  return (
    <DropdownButton
      id="dropdown-refund"
      bsSize="large"
      bsStyle="warning"
      title="Refund Type"
      className={className}
    >
      <MenuItem eventKey="1" onClick={handleTrueRefund}>
        True Refund
      </MenuItem>
      <MenuItem eventKey="2" onClick={handleCorrectionRefund}>
        Correction Refund
      </MenuItem>
    </DropdownButton>
  );
};

export default RefundPurchaseButton;
